module.exports = __webpack_public_path__ + "assets/img/produccion-oem-rakumart-1.2e460372.jpg";